module.exports = __webpack_public_path__ + "img/3m.81ec7892.png";